import { PLAN_GROUPS_WITH_DISABLED_CHECK_PSYCHIATRY_ELIGIBILITY_ON_SCHEDULE } from 'settings/_planGroupCode'


/**
 * Função para verificar se é necessário verificar a elegibilidade do paciente ao agendar uma consulta psiquiátrica
 * @param {string} selectedPlanGroupCode - Código do convênio selecionado do usuário logado
 * @returns {boolean} - Retorna true caso seja necessário verificar a elegibilidade do paciente ao agendar uma consulta psiquiátrica e false caso contrário
 */
export const shouldCheckPsychiatryEligibilityOnSchedule = (selectedPlanGroupCode: string): boolean => {
  if (PLAN_GROUPS_WITH_DISABLED_CHECK_PSYCHIATRY_ELIGIBILITY_ON_SCHEDULE.includes(selectedPlanGroupCode)) {
    return false
  }
  
  return true
}